





































import Vue from "vue";
import { PageDefinitions } from "@/interfaces/PageDefinitions";
import PageSelectItem from "@/components/PageSelectItem.vue";
import PageFilterButton from "@/components/PageFilterButton.vue";
type FilterVal = "all" | "vh1" | "mtv";
interface Filter {
  name: string;
  id: FilterVal;
}
interface Data {
  selected: FilterVal;
}
export default Vue.extend({
  components: { PageSelectItem, PageFilterButton },
  data() {
    return {
      selected: "all"
    };
  },
  computed: {
    pages(): PageDefinitions {
      return this.$store.state.page.all;
    },
    filteredPages(): PageDefinitions {
      // sort alphabetically.
      if (this.selected == "all") {
        return this.pages;
      }
      return this.pages.filter(
        pg => pg.prop == "any" || pg.prop == this.selected
      );
    },
    sortedPages(): PageDefinitions {
      const nonalpha = /[^a-z]*/i;
      return this.filteredPages.slice().sort((a, b) => {
        const ta = a.name.toUpperCase().replace(nonalpha, "");
        const tb = b.name.toUpperCase().replace(nonalpha, "");
        return ta < tb ? -1 : ta > tb ? 1 : 0;
      });
    },
    colors(): string[] {
      return ["auto"];
    },
    textColors(): string[] {
      return ["auto"];
    },
    filters(): Filter[] {
      return [
        {
          name: "All Pages",
          id: "all"
        }
      ];
    }
  },
  methods: {
    onFilter(filter: Filter): void {
      this.selected = filter.id;
    }
  }
});
